module.exports = __webpack_public_path__ + "static/fonts/iconfont.c40847e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont_ali/iconfont.woff?t=1582110905786
// module id = 1902
// module chunks = 115